import { render, staticRenderFns } from "./ButtonsFinal.vue?vue&type=template&id=78879cb4&scoped=true&"
import script from "./ButtonsFinal.vue?vue&type=script&lang=js&"
export * from "./ButtonsFinal.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsFinal.vue?vue&type=style&index=0&id=78879cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78879cb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
